import React, { CSSProperties, useState } from 'react';
import Map, { Marker }                    from 'react-map-gl'
import { MapMarker }                      from '@core/components/common/Maps/MapBox/MapMarker';
import AutoSizer                          from 'react-virtualized-auto-sizer';

import 'mapbox-gl/dist/mapbox-gl.css';


interface LatLong {
    lat?: number;
    long?: number;
}

interface Props {
    _key: string;
    _center?: LatLong;
    _zoom?: number;
    layer: 'streets-v11' | 'outdoors-v11' | 'light-v10' | 'dark-v10' | 'satellite-v9' | 'satellite-streets-v11' | 'navigation-day-v1' | 'navigation-night-v1';
    cssStyle?: CSSProperties;
    _mapSettings?: MapBoxSettings;
}

interface MapBoxSettings {
    scrollZoom: boolean;
    boxZoom: boolean;
    dragRotate: boolean;
    dragPan: boolean;
    keyboard: boolean;
    doubleClickZoom: boolean;
    touchZoomRotate: boolean;
    touchPitch: boolean;
    minZoom: number;
    maxZoom: number;
    minPitch: number;
    maxPitch: number;
}

const defaultSettings: MapBoxSettings = {
    scrollZoom: false,
    boxZoom: false,
    dragRotate: false,
    dragPan: false,
    keyboard: false,
    doubleClickZoom: false,
    touchZoomRotate: false,
    touchPitch: false,
    minZoom: 0,
    maxZoom: 18,
    minPitch: 0,
    maxPitch: 0
}

export const MBMap: React.FC<Props> = ({
                                           _key,
                                           _center,
                                           _zoom,
                                           layer,
                                           cssStyle,
                                           _mapSettings
                                       }) => {

    const mapSettings = _mapSettings || defaultSettings

    const [latLong, setLatLong] = useState({ lat: _center.lat, long: _center.long });
    const [containerWidth, setContainerWidth] = React.useState('auto');
    const mapRef = React.useRef();

    /*const toggleWidth = React.useCallback(
        () => setContainerWidth((w) => (w === '100vw' ? '50vw' : '100vw')),
        []
    );*/

    const onResize = React.useCallback(() => {
        if (mapRef.current) {
            // @ts-expect-error
            setTimeout(() => mapRef.current.resize(), 0);
        }
        return null;
    }, []);


    return (
        /*<Map
            reuseMaps={true}
            initialViewState={{
                longitude: latLong.long,
                latitude: latLong.lat,
                zoom: _zoom,
                bearing: 360,
                pitch: 180,
            }}
            {...mapSettings}
            mapStyle={`mapbox://styles/mapbox/${layer}`}
            mapboxAccessToken={_key}
            style={cssStyle}
        >

            {
                <GeolocateControl positionOptions={{ enableHighAccuracy: true }}
                               trackUserLocation
                               showUserLocation
                               position="top-left"/>
            }
            {/!*<FullscreenControl position="top-left"/>*!/}
            {/!*<NavigationControl position="top-left"/>*!/}
            {/!*<ScaleControl/>*!/}

            <Marker
                latitude={latLong.lat}
                longitude={latLong.long}
                anchor="bottom"
            >
                <MapMarker/>
            </Marker>

            <Marker longitude={latLong.long} latitude={latLong.lat}>
                <div style={{ color: 'red' }}>I am here</div>
            </Marker>

        </Map>*/

        // NEW
        <div style={{
            width: containerWidth,
            height: '350px',
            marginBottom: '0',
            borderRadius: 6,
            transition: 'width 1s'
        }}>

            <AutoSizer>{onResize}</AutoSizer>

            <Map
                initialViewState={{
                    longitude: latLong.long,
                    latitude: latLong.lat,
                    zoom: _zoom,
                    bearing: 360,
                    pitch: 180,
                }}
                {...mapSettings}
                mapStyle={`mapbox://styles/mapbox/${layer}`}
                mapboxAccessToken={_key}
                // style={cssStyle}
                style={{ width: 'auto', height: '100%' }}
                ref={mapRef}
            >
                {/*{<FullscreenControl position="top-left"/>}*/}
                {/*{<NavigationControl position="top-left"/>}*/}
                {/*{<ScaleControl/>}*/}

                <Marker
                    latitude={latLong.lat}
                    longitude={latLong.long}
                    offset={[20, 50]}
                    anchor="bottom"
                >
                    <MapMarker/>
                </Marker>
            </Map>
        </div>


    );

}
